import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20home%20theater%20with%20large%20screen%20displaying%20vibrant%20movie%20scene%2C%20warm%20cozy%20living%20room%20atmosphere%2C%20soft%20ambient%20lighting%2C%20modern%20interior%20design%2C%20entertainment%20lifestyle%2C%20rich%20coral%20and%20golden%20warm%20tones%2C%20cinematic%20photography&width=1920&height=1080&seq=hongtao-hero-01&orientation=landscape"
          alt="红桃影视 - 高清影视资源在线观看平台"
          title="红桃影视高清影视在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            红桃影视
          </h1>
          <p className="text-lg md:text-xl text-background-200 mb-3 font-light">
            海量高清影视，随时随地畅享
          </p>
          <p className="text-sm md:text-base text-background-300/80 mb-8 max-w-xl mx-auto">
            汇聚全球优质影视资源，每日更新最新内容，支持多端流畅播放
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/dianying"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观影
            </Link>
            <a
              href="#"
              className="px-8 py-3 rounded-full border border-background-300/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-2"></i>
              下载APP
            </a>
          </div>
        </div>

        <div className="mt-12 flex items-center justify-center gap-6 md:gap-10">
          {[
            { value: '5000万+', label: '累计用户' },
            { value: '10万+', label: '影视资源' },
            { value: '98.5%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-300/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}